import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// Redux
import { connect } from 'react-redux';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Redux Action
import { contactHostOpen } from '../../../actions/message/contactHostModal';

// Translation
import { injectIntl } from 'react-intl';

// Locale
import messages from '../../../locale/jsonMessages';

// Component
import Avatar from '../../Avatar';
import Link from '../../Link';

import { checkValue } from '../ListingDetails/helper';
import { getDynamicName } from '../../../helpers/GetDynamicItemName/getDynamicName';

//Images
import carTypeIcon from '/public/SiteIcons/carTypeIcon.svg';
import modelIcon from '/public/SiteIcons/modelIcon.svg';
import calendarIcon from '/public/SiteIcons/calendarIcon.svg';
import speedometerIcon from '/public/SiteIcons/speedometerIcon.svg';
import makeIcon from '/public/SiteIcons/makeIcon.svg';
import transmissionIcon from '/public/SiteIcons/transmissionIcon.svg';
import { dateFormat } from '../../../config';
import { formatLocalizedDate } from '../../../helpers/formatLocateDate';

import cs from '../../../components/commonStyle.css';
import c from '../../../components/ViewListing/common.css';
import s from './ListingIntro.css';

class ListingIntro extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    formatMessage: PropTypes.any,
    contactHostOpen: PropTypes.any.isRequired,
  };

  dynamicTitle = ({ data }) => {
    const { locale, dynamicLanguageData } = this.props;
    let title = getDynamicName({ value: data, locale, data: dynamicLanguageData });
    return title?.itemName || data?.itemName
  }

  render() {
    const { data, isHost, userBanStatus, contactHostOpen, id, locale, dynamicLanguageData } = this.props;
    const { formatMessage } = this.props.intl;
    let joinedDate, transmission;
    joinedDate = data.user.profile.createdAt != null ? formatLocalizedDate(data.user.profile.createdAt, locale, dateFormat?.monthYearFormat) : '';
    transmission = data.transmission == '1' ? formatMessage(messages.automatic) : formatMessage(messages.manual);

    return (
      <>
        <div className={s.gridColumn}>
          <div className={c.avatarImage}>
            <Avatar
              source={data.user.profile.picture}
              type={"small"}
              height={80}
              width={80}
              title={data.user.profile.firstName}
              className={cx(s.profileAvatar, c.profileAvatarLink)}
              withLink
              linkClassName={cs.displayinlineBlock}
              profileId={data.user.profile.profileId}
            />
            <div className={cx(s.textSection, 'viewListingTextSectionRTL')}>
              <a href={"/users/show/" + data.user.profile.profileId} target={'_blank'} className={cx(cs.commonSubTitleText, cs.siteTextColor, cs.fontWeightBold)}>
                {formatMessage(messages.hostedBy)} {' '}  <span className={cs.siteLinkColor}> {data.user.profile.firstName} </span>
              </a>
              <h4 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.paddingTop1)}>
                {formatMessage(messages.joinedIn)}{' '}{joinedDate}
              </h4>
            </div>
          </div>
          {
            !isHost && !userBanStatus && <Link noLink className={cx(cs.btnPrimary, cs.btnBig, cs.displayinlineBlock, s.mobileMargin)} onClick={(e) => { e.preventDefault(); contactHostOpen(id) }}>
              {formatMessage(messages.contactHost)}
            </Link>
          }
        </div>
        <hr className={cs.listingHorizoltalLine} />
        <div className={s.displayGrid}>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={carTypeIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.carType)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{this.dynamicTitle({ data: data?.settingsData[0]?.listsettings })}</h5>
          </div>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={makeIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.whatTypeOfProperty)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{this.dynamicTitle({ data: data?.settingsData[3]?.listsettings })}</h5>
          </div>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={modelIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.modelLabel)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{this.dynamicTitle({ data: data?.settingsData[1]?.listsettings })}</h5>
          </div>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={calendarIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.year)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{this.dynamicTitle({ data: data?.settingsData[2]?.listsettings })}</h5>
          </div>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={transmissionIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.isPersonalHome)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{transmission}</h5>
          </div>
          <div className={cx(s.gridBoxSection, cs.spaceBottom4, 'viewListingGridBoxRTL')}>
            <img src={speedometerIcon} className={cx(cs.spaceBottom3, s.listingIntroImage)} />
            <h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom1)}>{formatMessage(messages.odometer)}</h4>
            <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.textSection)}>{this.dynamicTitle({ data: data?.settingsData[4]?.listsettings })}</h5>
          </div>
        </div>
      </>
    );
  }
}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data
});

const mapDispatch = {
  contactHostOpen
};

export default injectIntl(withStyles(cs, c, s)(connect(mapState, mapDispatch)(ListingIntro)));